import type { ContextMeshCategoryKey } from "./contextMeshAnalysis";

export const CONTEXT_MESH_NAVY = "#0B2966";
export const CONTEXT_MESH_WHITE = "#FFFFFF";

export interface ContextMeshCategoryTheme {
    key: ContextMeshCategoryKey;
    title: string;
    shortTitle: string;
    subtitle: string;
    color: string;
    /** Text rendered directly on the category color. */
    labelColor: string;
    /** Accessible category-colored text rendered on a light surface. */
    accentColor: string;
}

export const CONTEXT_MESH_CATEGORY_THEME: Readonly<Record<ContextMeshCategoryKey, ContextMeshCategoryTheme>> = {
    discover: {
        key: "discover",
        title: "Discover Context",
        shortTitle: "Discover",
        subtitle: "What is the product?",
        color: "#103699",
        labelColor: CONTEXT_MESH_WHITE,
        accentColor: "#103699"
    },
    external: {
        key: "external",
        title: "External Context",
        shortTitle: "External",
        subtitle: "Jira / DevOps",
        color: "#DBE5FF",
        labelColor: CONTEXT_MESH_NAVY,
        accentColor: CONTEXT_MESH_NAVY
    },
    code: {
        key: "code",
        title: "Code Context",
        shortTitle: "Code",
        subtitle: "Git projects",
        color: "#1954ED",
        labelColor: CONTEXT_MESH_WHITE,
        accentColor: "#1954ED"
    },
    file: {
        key: "file",
        title: "File Context",
        shortTitle: "File",
        subtitle: "Your project files",
        color: "#A3BBF8",
        labelColor: CONTEXT_MESH_NAVY,
        accentColor: CONTEXT_MESH_NAVY
    }
};

/** Canonical display order shared by Context Mesh summaries and detail views. */
export const CONTEXT_MESH_CATEGORIES: readonly ContextMeshCategoryTheme[] = [
    CONTEXT_MESH_CATEGORY_THEME.discover,
    CONTEXT_MESH_CATEGORY_THEME.external,
    CONTEXT_MESH_CATEGORY_THEME.file,
    CONTEXT_MESH_CATEGORY_THEME.code
];
